import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject, Subject} from "rxjs";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {first, take} from "rxjs/operators";
import {Uuid} from "../interface/response/uuid";
import {AdditionalField} from "../interface/additionalField";
import {ListResponse} from "../interface/response/list-response";

@Injectable({
  providedIn: 'root'
})
export class AdditionalFieldsService {
  private readonly additionalFieldsListSubject: ReplaySubject<CountedAndPaginated<AdditionalField>>
    = new ReplaySubject<CountedAndPaginated<AdditionalField>>(1);
  private readonly additionalFieldsListSubjects: ReplaySubject<ListResponse<AdditionalField>>
    = new ReplaySubject<ListResponse<AdditionalField>>(1);


  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public deleteAdditionalField(uuid: string): Observable<any> {
    return this.httpClient.delete(`/rest/crm/additional-field/${uuid}`)
      .pipe(first());
  }

  public addAdditionalField(formData: object): Observable<Uuid> {
    return this.httpClient.post<Uuid>('/rest/crm/additional-field', formData)
      .pipe(take(1));
  }

  public loadAdditionalFieldList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/additional-field?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(first())
      .subscribe((result: CountedAndPaginated<AdditionalField>) => {
        this.additionalFieldsListSubject.next(result);
      });
  }

  public getAdditionalFieldsListSubject(): ReplaySubject<CountedAndPaginated<AdditionalField>> {
    return this.additionalFieldsListSubject;
  }

  public loadNotCountedList(page: number, pageSize: number, filters: object, subject?: Subject<ListResponse<AdditionalField>>): void {
    this.httpClient
      .get(`/rest/crm/additional-field?disableCount=1&page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(take(1))
      .subscribe((result: ListResponse<AdditionalField>) => {
        if (subject) {
          subject.next(result);
        } else {
          this.additionalFieldsListSubjects.next(result);
        }
      });
  }

  public updateActive(formData: object, additionalFieldId: string): Observable<any> {
    return this.httpClient.put(`/rest/crm/additional-field/${additionalFieldId}/updateActive`, formData)
      .pipe(first());
  }

  public getAdditionalField(uuid: string): Observable<AdditionalField> {
    return this.httpClient.get(`/rest/crm/additional-field/${uuid}`)
      .pipe(first()) as Observable<AdditionalField>;
  }

}
